module.exports = __webpack_public_path__ + "img/touKui4.c5a5b006.png";